import type { ReportMessages } from '../de/report.js';

export const report: ReportMessages = {
  title: 'Design report',
  fileWord: 'Design-report',
  disclaimer: 'Concept/design planning – not for construction, permit or structural planning.',
  header: '{title} · As of {date} · Revision {revision}',
  page: 'Page {page} of {total}',
  createdBy: 'Design report of {date} · created by {author}',
  description: 'Project description',
  figuresTitle: 'Key figures',
  noView: 'No 3D view provided.',
  plan: 'Floor plan',
  planLevel: 'Floor plan {level}',
  nothingPlanned: 'Nothing planned yet.',
  scale: 'Scale 1:{scale}',
  scaleHint: 'when printed on A4 without scaling',
  legendTitle: 'Legend',
  unitsMeters: 'Dimensions in metres',
  units: 'Dimensions in {unit}',
  north: 'N',
  view: '3D view {n}',
  views: { southEast: 'View from the south-east', northWest: 'View from the north-west' },
  tablesTitle: 'Areas and components',
  tablesContinued: 'Areas and components (continued)',
  notesTitle: 'Planning notes',
  notesHint: 'The notes are geometric plausibility checks and do not replace specialist planning.',
  total: 'Total',
  sum: 'Total',
  roofTypes: { gable: 'Gable roof', mono: 'Mono-pitch roof', flat: 'Flat roof' },
  figures: {
    site: 'Site',
    parcels: 'Parcels',
    built: 'Built-up area',
    coverage: 'Site coverage (built / site)',
    free: 'Free site area',
    halls: 'Halls',
    offices: 'Office buildings',
    officeArea: 'Office area (GFA, all floors)',
    traffic: 'Traffic areas',
    carStalls: 'Car parking spaces',
    truckStalls: 'Truck parking spaces',
    fence: 'Fence length',
    palletPlaces: 'Pallet places',
    shelfPlaces: 'Shelf places',
    shelfArea: 'Shelf area',
  },
  parcels: {
    title: 'Site (parcels)',
    columns: ['Parcel', 'Area', 'Perimeter'],
  },
  offices: {
    title: 'Office buildings',
    columns: [
      'Building',
      'Location',
      'Outer dimensions',
      'Floors (clear height)',
      'Slab',
      'Total height',
      'GFA',
    ],
    indoor: 'Built-in',
    indoorIn: 'Built into {hall}',
    freestanding: 'free-standing',
    usableTop: 'roof deck usable',
  },
  roomBook: {
    title: 'Room schedule {name}',
    columns: ['Floor', 'Room', 'Room type', 'Area', 'Clear height'],
    unassigned: 'unassigned',
    rooms: { one: '{n} room', other: '{n} rooms' },
  },
  stairs: {
    title: 'Stairs',
    columns: [
      'Stair',
      'Building',
      'Connection',
      'Flight width',
      'Risers',
      'Rise / going',
      'Footprint',
    ],
    enclosed: '{name} (stairwell)',
    landing: '{name}, landing {length}',
    ratio: '{riser} / {going} cm',
  },
  halls: {
    title: 'Halls',
    freeOutline: 'Free outline ({n} corners)',
    columns: [
      'Hall',
      'Outer dimensions',
      'Area',
      'Usable interior area',
      'Eave / ridge',
      'Roof',
      'Openings',
    ],
  },
  mezzanines: {
    title: 'Mezzanines in halls (1st floor)',
    columns: ['Mezzanine', 'Hall', 'Floor level', 'Slab', 'Equipment', 'Area'],
    railing: 'Railing',
    columns_: 'Columns',
  },
  mezzanineAreas: {
    title: 'Division of {name} (by walls, without wall thickness)',
    columns: ['Area', 'Size', 'Share'],
  },
  zones: {
    title: 'Area breakdown {name}',
    columns: ['Zone', 'Type', 'Area', 'Share'],
    room: 'Room',
    unplanned: 'not yet planned',
    interior: 'Usable interior area',
  },
  sections: {
    title: 'Hall sections {name} (by partition walls, measured to the wall axis)',
    columns: ['Section', 'Area', 'Share'],
  },
  outdoorZones: {
    title: 'Outdoor areas',
    columns: ['Area', 'Type', 'Size'],
  },
  openings: {
    title: 'Gates, doors and windows',
    columns: ['Hall', 'Type', 'Size (W × H)', 'Count'],
    interiorWalls: 'Interior walls',
    sill: 'sill {length}',
    bay: 'approach {width} × {length}',
  },
  roof: {
    title: 'Roof elements',
    columns: ['Hall', 'Element', 'Count', 'Area'],
    daylight: 'Roof daylight share',
  },
  objects: {
    title: 'Objects',
    columns: ['Name', 'Size (W × D × H)', 'Count'],
  },
  racks: {
    title: 'Pallet racks',
    columns: ['Rack', 'Beam', 'Bays', 'Levels', 'Places 1.60 m', 'Places 0.80 m', 'Pallet places'],
  },
  shelves: {
    title: 'Shelving units',
    columns: ['Unit', 'Height', 'Bays', 'Compartments', 'Places (carton 30 × 60 cm)', 'Shelf area'],
  },
  facilities: {
    title: 'Outdoor facilities',
    columns: ['Name', 'Type', 'Dimensions', 'Area'],
    road: '{width} wide, {length} long',
    parking: '{stall}, aisle {aisle}',
    fence: 'Fence',
    fenceSize: '{length} long, {height} high',
  },
  legend: {
    site: 'Site boundary',
    parcel: 'Parcel boundary',
    hall: 'Hall / exterior wall',
    room: 'Room',
    dock: 'Dock approach (lowered)',
    object: 'Object',
    clearance: 'Safety/operating clearance',
    roofElement: 'Roof element (above)',
    road: 'Road / path',
    parking: 'Parking area',
    fence: 'Fence',
    measure: 'Dimension',
    stair: 'Stair (arrow = up)',
  },
};
